'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = require('../util');

exports.default = {
  redeem: function redeem(api, data, fragment, voucherAction) {
    var query = 'mutation { redeeemVoucher(id: "' + data.id + '") { ' + fragment + ' } }';

    var queryName = 'redeeemVoucher';
    return (0, _util.wrapAction)(voucherAction, queryName, 'redeem', api.fetch(query, {}, queryName));
  },
  create: function create(api, data, fragment, voucherAction) {
    var fields = ['app', 'discount', 'source', 'active', 'validityPeriod', 'message'];
    var args = (0, _util.serializeFields)(fields, data);
    var query = 'mutation { createVoucher(' + args + ') { ' + fragment + ' } }';

    var queryName = 'createVoucher';
    return (0, _util.wrapAction)(voucherAction, queryName, 'create', api.fetch(query, {}, queryName));
  },
  update: function update(api, data, fragment, voucherAction) {
    var fields = ['id', 'app', 'discount', 'active', 'validityPeriod', 'message'];
    var args = (0, _util.serializeFields)(fields, data);
    var query = 'mutation { updateVoucher(' + args + ') { ' + fragment + ' } }';

    var queryName = 'updateVoucher';
    return (0, _util.wrapAction)(voucherAction, queryName, 'update', api.fetch(query, {}, queryName));
  },


  /*
  NB: il filtro su redeemed è per l'instance, non per il prototipo del voucher. E' riportato in corrispondenza
  di vouchers perché veniva più comodo e più intuitivo su GraphQL
  */
  getMine: function getMine(api, voucherAction) {
    var query = 'query {\n      me {\n        vouchers(redeemed: false) {\n          id\n          validityPeriod {\n            from\n            to\n          }\n          source\n          active\n          image\n          constraints {\n            inStore\n            modules {\n              module\n              services {\n                name\n                active\n              }\n            }\n            threshold\n          }\n          discount {\n            amount\n            format\n          }\n          message\n          instance {\n            id\n            redeemed\n            redemptionDate\n            invalidated\n          }\n        }\n      }\n    }';

    var queryName = 'me:voucher:getMine';
    return (0, _util.wrapAction)(voucherAction, 'me', 'getMine', api.fetch(query, {}, queryName));
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-lib/lib/service/voucher.js
// module id = 204
// module chunks = 0